import {useCallback} from 'react';
import {useTranslation} from 'react-i18next';

/**
 * Читает триплет {ru, kk, en} из данных курса на текущем языке.
 *
 * Почему не LocalName.getName: тот лезет в localStorage напрямую и потому не реактивен —
 * после переключения языка компонент не перерисуется, пока его не тронет что-то ещё.
 * Здесь подписка на useTranslation(), поэтому смена языка перерисовывает всё дерево.
 */
export const useLocalizedText = () => {
    const {i18n} = useTranslation();
    const lang = i18n.language === 'kk' ? 'kk' : (i18n.language === 'en' ? 'en' : 'ru');

    return useCallback((triplet) => {
        if (triplet === null || triplet === undefined) return '';
        if (typeof triplet === 'string') return triplet;
        return triplet[lang] || triplet.ru || '';
    }, [lang]);
};

export default useLocalizedText;
